<div *ngIf="!AccessAllowed && CompletedLoading">
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
</div>

<div *ngIf="AccessAllowed" class="p-3 flex flex-column flex-auto">
    <div class="text-900 font-medium text-xl mb-3"><h3>Product Options</h3></div>
    <p class="m-0 mb-4 p-0 text-600 line-height-3 mr-3">
        <span class="pi pi-info-circle" style="margin-right:2px;"></span>
        Manage the global list of product options available for this venue. Options can be attached to products individually.
    </p>
    <div style="text-align: right; margin-bottom: 20px;">
        <p-toggleButton class="p-button-sm p-button-danger p-component"
            [(ngModel)]="isDisabled"
            onLabel="Show Disabled" offLabel="Hide Disabled"
            offIcon="pi pi-times" onIcon="pi pi-check"
            [style]="{'margin-right': '10px', 'color': 'white', 'background-color': '#EF4444', 'height': '50px'}"
            (click)="toggleDisabled()">
        </p-toggleButton>

        <span class="p-input-icon-left ml-auto" style="margin-right:20px;">
            <i class="pi pi-search"></i>
            <input pInputText type="text" (input)="optionsTable.filterGlobal($event.target.value, 'contains')" style="height: 50px; padding-left:33px;" />
        </span>

        <button pButton type="button" style="height: 50px;" class="p-button-sm p-element p-ripple p-button-success p-button p-component" [routerLink]="['/tillproductoptionsedit/0']">
            <span class="pi pi-plus" style="margin-right:8px;"></span>
            <span>Add</span>
        </button>
        &nbsp;
        <button pButton type="button" style="height: 50px;" class="p-button-sm p-element p-ripple p-button-danger p-button p-component" (click)="disableMulti()">
            <span class="pi pi-trash" style="margin-right:8px;"></span>
            <span>Disable</span>
        </button>
    </div>

    <div class="surface-card p-4 shadow-2 border-round">
        <p-table #optionsTable
            [value]="ListOptions"
            sortField="name"
            [paginator]="true" [rows]="10"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            [rowsPerPageOptions]="[10,25,50]"
            [globalFilterFields]="['name']"
            [(selection)]="selectedItems"
            dataKey="id"
            [selectionPageOnly]="true"
            responsiveLayout="scroll">
            <ng-template pTemplate="header">
                <tr>
                    <th><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
                    <th pSortableColumn="name" width="50%">Name <p-sortIcon field="name"></p-sortIcon></th>
                    <th pSortableColumn="price" width="20%">Price <p-sortIcon field="price"></p-sortIcon></th>
                    <th width="15%">Status</th>
                    <th width="5%"></th>
                    <th width="5%"></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data>
                <tr [ngStyle]="{'background-color': data.disabled ? '#fee' : '#ffffff'}">
                    <td><p-tableCheckbox [value]="data"></p-tableCheckbox></td>
                    <td>{{ data.name }}</td>
                    <td>{{ data.price | currency:'GBP' }}</td>
                    <td>
                        <span *ngIf="!data.disabled" class="pi pi-check-circle" style="color:#16a34a; font-size:16px;"></span>
                        <span *ngIf="data.disabled" class="pi pi-times-circle" style="color:#ef4444; font-size:16px;"></span>
                        {{ data.disabled ? ' Disabled' : ' Active' }}
                    </td>
                    <td>
                        <button pButton type="button" class="p-button-sm p-element p-ripple p-button-success p-button p-component" (click)="editData(data.tillproductoptionid)">
                            <span class="pi pi-pencil" style="margin-right:8px;"></span>Edit
                        </button>
                    </td>
                    <td>
                        <button pButton type="button" class="p-button-sm p-element p-ripple p-button-danger p-button p-component" style="margin-left:-20px;" (click)="disableData(data.id)">
                            <span class="pi pi-trash" style="margin-right:8px;"></span>Disable
                        </button>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="6" style="text-align:center; padding: 40px; color: #9ca3af;">
                        No product options found. Click Add to create your first option.
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
